import { Tag } from '@cian/components';
import * as React from 'react';

import { ERoomsTotal } from '../../../../json_query';
import { IRoomsTotalTag } from '../../../state/tags/definitions/rooms_total';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IRoomsTotalTagItemProps {
  tag: IRoomsTotalTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const roomsTotalMap = {
  [ERoomsTotal.One]: 'от 1',
  [ERoomsTotal.Two]: 'от 2',
  [ERoomsTotal.Three]: 'от 3',
  [ERoomsTotal.Four]: 'от 4',
  [ERoomsTotal.Five]: 'от 5',
};

export const RoomsTotalTagItem = ({ tag, onDeleteClick, withNewTag }: IRoomsTotalTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === ERoomsTotal.Any) {
    return null;
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Комнат в квартире: {roomsTotalMap[tag.value]}
    </TagComponent>
  );
};
